export default "__VITE_ASSET__DPsweE84__"